import './FecetFilters.scss';
import { useState } from 'react';

const FacetFilters = ({ filterData, clearGroupFilter }: any) => {
    const [showTooltip, setTooltipFlag] = useState(false);
    const filters = filterData.map((data: any, i: any) => {
        let finalValue = '';
        let valuesLength = data['values'].length;
        let index = 1;
        if(data.key === "Locations"){
            let jsonValue = {'latitude': data.values.latitude ,'longitude': data.values.longitude,"radius": data.values.radius};
            finalValue = JSON.stringify(jsonValue);
        } else {
            data['values'].forEach((val: string) => {
                if (index !== valuesLength) val = val + ', ';

                finalValue = finalValue + val;

                index = index + 1;
            });
        }

        const tooltipMouseEnter = (key: any) => {
            let elementDiv = document.getElementById('div-' + key);

            let scrollWidth = elementDiv?.scrollWidth;
            let offsetWidth = elementDiv?.offsetWidth;

            if (scrollWidth !== undefined && offsetWidth !== undefined && scrollWidth > offsetWidth) {
                setTooltipFlag(true);
            } else {
                setTooltipFlag(false);
            }
        };

        return (
            <li className="filter-data-list" key={data['key']}>
                <div title={data['key']} className="filter-data-div">
                    {data['key']}
                </div>
                <div
                    id={`div-${data['key']}`}
                    title={showTooltip ? finalValue : ''}
                    className="filter-values-div"
                    onMouseEnter={() => tooltipMouseEnter(data['key'])}
                >
                    : &nbsp; <b>{finalValue}</b>
                </div>
                <div className="close-filter-icon material-icons" title="Close" onClick={() => clearGroupFilter(data['name'], finalValue)}>
                    close
                </div>
            </li>
        );
    });

    return filters;
};

export default FacetFilters;
